import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";
import { FormCheckboxGroup } from "../../common/FormCheckboxGroup";
import { PersonalisedLearningSupportPlanData } from "src/models/form-types";

interface LevelOfAdjustmentSectionProps {
  formData: PersonalisedLearningSupportPlanData;
  onCheckboxChange: (
    name: string,
    checked: boolean,
    category: keyof PersonalisedLearningSupportPlanData
  ) => void;
  className?: string;
}

// Define the adjustment level options
const adjustmentLevelOptions = [
  {
    id: "adjustment-qdtp",
    name: "Quality Differentiated Teaching Practice (QDTP)",
    label: "Quality Differentiated Teaching Practice (QDTP)",
  },
  {
    id: "adjustment-supplementary",
    name: "Supplementary",
    label: "Supplementary",
  },
  {
    id: "adjustment-substantial",
    name: "Substantial",
    label: "Substantial",
  },
  {
    id: "adjustment-extensive",
    name: "Extensive",
    label: "Extensive",
  },
];

export const LevelOfAdjustmentSection: React.FC<
  LevelOfAdjustmentSectionProps
> = ({ formData, onCheckboxChange, className }) => {
  // Handle adjustment level change
  const handleAdjustmentLevelChange = (name: string, checked: boolean) => {
    // Enforce single selection (radio-like behaviour)
    if (checked) {
      if (Array.isArray(formData.levelOfAdjustment)) {
        formData.levelOfAdjustment.forEach((option) => {
          if (option !== name) {
            onCheckboxChange(option, false, "levelOfAdjustment");
          }
        });
      }
      onCheckboxChange(name, true, "levelOfAdjustment");
    } else {
      onCheckboxChange(name, false, "levelOfAdjustment");
    }
  };

  return (
    <CollapsibleFormSection title="Level of Adjustment" className={className}>
      <FormCheckboxGroup
        options={adjustmentLevelOptions}
        selectedValues={formData.levelOfAdjustment}
        onChange={handleAdjustmentLevelChange}
        columns={2}
      />
    </CollapsibleFormSection>
  );
};
